import { ServiceTitanExternalLink } from "./service-titan-external-link";

interface ServiceTitanInvoiceLinkProps {
  invoiceId: number;
}

export const ServiceTitanInvoiceLink = ({
  invoiceId,
}: ServiceTitanInvoiceLinkProps) => {
  const url = `/#/Invoice/${invoiceId}`;

  return (
    <ServiceTitanExternalLink url={url}>
      ServiceTitan invoice {invoiceId}
    </ServiceTitanExternalLink>
  );
};
